export interface ISolarAccountBalanceResponse {
  accountBalance: number;
}

export class SolarAccountBalanceResponse
  implements ISolarAccountBalanceResponse {
  accountBalance: number;
}
